import React from 'react';
import CandidateForm from '../../components/HR/CandidateForm';
import type { Job, Application } from './types';

interface CandidateFormModalProps {
  editingApplication: Application | null;
  selectedJobForApply: Job | null;
  jobs: Job[];
  onSubmit: (data: any) => Promise<void>;
  onCancel: () => void;
}

const CandidateFormModal: React.FC<CandidateFormModalProps> = ({
  editingApplication, selectedJobForApply, jobs, onSubmit, onCancel,
}) => {
  const rc = editingApplication?.rawCandidate;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto py-8">
      <div className="relative w-full max-w-6xl mx-4">
        <div className="max-h-[90vh] overflow-y-auto">
          <CandidateForm
            candidate={editingApplication ? {
              id: editingApplication.id,
              firstName: rc?.firstName ?? editingApplication.candidateName.split(' ')[0] ?? '',
              lastName: rc?.lastName ?? editingApplication.candidateName.split(' ').slice(1).join(' ') ?? '',
              email: rc?.email ?? editingApplication.email,
              phone: rc?.phone ?? editingApplication.phone,
              nationality: rc?.nationality ?? '',
              dateOfBirth: rc?.dateOfBirth ?? '',
              appliedPosition: rc?.appliedPosition ?? editingApplication.jobId,
              source: rc?.source ?? 'website',
              experience: rc?.experience ?? 0,
              education: rc?.education ?? '',
              certificates: rc?.certificates ?? [],
              languages: rc?.languages ?? [],
              previousCompany: rc?.previousCompany ?? '',
              expectedSalary: rc?.expectedSalary ?? 0,
              availableFrom: rc?.availableFrom ?? '',
              coverLetter: rc?.coverLetter ?? '',
              status: (editingApplication.rawStatus || 'new') as any,
              assignedManagerId: rc?.assignedManagerId ?? '',
              assignedManagerName: rc?.assignedManagerName ?? '',
              managerFeedback: rc?.managerFeedback ?? '',
              notes: editingApplication.notes || rc?.notes || '',
              rating: rc?.rating ?? editingApplication.rating,
              totalRating: editingApplication.totalRating,
              appliedDate: editingApplication.appliedDate,
              resumeUrl: rc?.resumeUrl ?? editingApplication.resume,
              applicationPdfUrl: rc?.applicationPdfUrl,
              interviewDate: rc?.interviewDate,
              createdAt: rc?.createdAt ?? new Date().toISOString(),
              updatedAt: rc?.updatedAt ?? new Date().toISOString()
            } : undefined}
            onSubmit={onSubmit}
            onCancel={onCancel}
          />
        </div>
      </div>
    </div>
  );
};

export default CandidateFormModal;
